var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { click: _vm.select } },
    [
      _vm.value
        ? _c("ItemImage", { attrs: { item: _vm.value, size: _vm.imageSize } })
        : _c("i", {
            staticClass: "empty",
            class: "size-" + _vm.imageSize,
            style: { "padding-top": _vm.sizeratio }
          }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn", attrs: { type: "button" } },
        [
          _vm.value
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("trans")("images:attach.title")) +
                    "\n    "
                )
              ]
            : [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("trans")("images:attach.title_add")) +
                    "\n    "
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79d377d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d377d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/form/ImageSelect.vue
// module id = null
// module chunks = 